import React from 'react';
import { Icon } from '@osmosis/react-ui/components/Icon';
import { faBookSpells } from '@fortawesome/pro-duotone-svg-icons/faBookSpells';
import { FormattedMessage } from 'react-intl';
import { Box } from '@osmosis/react-ui/components/Box';
import { Card } from '@osmosis/react-ui/components/Card';
import { P } from '@osmosis/react-ui/components/Text';
import { faFlame } from '@fortawesome/pro-duotone-svg-icons/faFlame';

type Props = {
  streak: number;
  xp: number;
};

/**
 * Count XP and streaks.
 */
const QuizXPCount = (props: Props) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        gap: '48px',
        justifyContent: 'center',
        marginY: '48px',
      }}
    >
      <Card
        width="35%"
        padding={3}
        display="flex"
        flexDirection="row"
        alignItems="center"
      >
        <Icon
          icon={faFlame}
          data-tip
          data-tooltip-id={'streak_id'}
          data-testid={'react-tooltip-icon'}
          color="orange"
          style={{ width: '36px', height: '36px', marginRight: '16px' }}
        />
        <Box>
          <P fontSize={24} fontWeight={700}>
            {props.streak}
          </P>
          <P>
            <FormattedMessage
              id="quiz.summary.dailyStreak"
              defaultMessage="Day streak"
            />
          </P>
        </Box>
      </Card>
      <Card
        width="35%"
        padding={3}
        display="flex"
        flexDirection="row"
        alignItems="center"
      >
        <Icon
          icon={faBookSpells}
          color="#2079df"
          style={{ width: '36px', height: '36px', marginRight: '16px' }}
        />
        <Box>
          <P fontSize={24} fontWeight={700}>
            {props.xp}
          </P>
          <P>
            <FormattedMessage id="quiz.summary.XP" defaultMessage="Total XP" />
          </P>
        </Box>
      </Card>
    </Box>
  );
};

export default QuizXPCount;
